import './Services.css'
import Service from "./Service";
import Separator from "../separator/Separator";

const Services = ({services}) => {
    return (
        <div className={"h-service"}>
            <div className={"container"}>

                <section id={"service"}>

                    <div className={"service-container"}>

                        <div className={"row"}>
                            <div className={"col-12"}>

                                <h1 className={"title"}>Nos services</h1>
                            </div>
                            {
                                services.map((service) => (
                                    <Service
                                        key={service.id}
                                        title={service.title}
                                        description={service.description}
                                        image={service.photo}
                                    />
                                ))
                            }
                        </div>
                        <Separator first={"legume/soja.webp"} second={"legume/ovy.webp"} third={"legume/haricot.webp"}></Separator>

                    </div>
                </section>
            </div>
        </div>
    )
}

export default Services;